import React, { useState } from 'react';
import { 
    Box, 
    Typography, 
    Tabs,
    Tab,
    Alert,
    Snackbar,
    Button
} from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import HistoryIcon from '@mui/icons-material/History';
import ComputerIcon from '@mui/icons-material/Computer';

import ActiveSessionsTab from './components/ActiveSessionsTab';
import AuditLogsTab from './components/AuditLogsTab';
import MfaSettingsTab from './components/MfaSettingsTab';

export default function SecurityManagement() {
    const [tab, setTab] = useState(0);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h4" fontWeight="bold">Security & Authentication</Typography>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: '#eaecf0', mb: 3 }}>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                    <Tab icon={<ComputerIcon />} iconPosition="start" label="Active Sessions" />
                    <Tab icon={<HistoryIcon />} iconPosition="start" label="Audit Logs" />
                    {/* Temporarily hidden: MFA Settings Tab */}
                    {false && <Tab icon={<SecurityIcon />} iconPosition="start" label="MFA Settings" />}
                </Tabs>
            </Box>

            {/* ─── Tab 0: Active Sessions ──────────────────────────────────── */}
            {tab === 0 && (
                <ActiveSessionsTab setNotification={setNotification} />
            )}

            {/* ─── Tab 1: Audit Logs ───────────────────────────────────────── */}
            {tab === 1 && (
                <AuditLogsTab setNotification={setNotification} />
            )}

            {/* ─── Tab 2: MFA Settings (Temporarily hidden) ─────────────────── */}
            {false && tab === 2 && (
                <MfaSettingsTab setNotification={setNotification} />
            )}

            {/* ─── Notification Snackbar ────────────────────────────────────── */}
            <Snackbar
                open={notification.open}
                autoHideDuration={5000}
                onClose={() => setNotification(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    onClose={() => setNotification(prev => ({ ...prev, open: false }))} 
                    severity={notification.severity} 
                    sx={{ width: '100%' }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
